import { useConnectors } from 'wagmi';
import { WALLET_ORDER } from '../utils/constants';

export const useWalletList = () => {
  const connectors = useConnectors();
  
  return WALLET_ORDER?.map(walletName => {
    const connector = connectors?.find(c =>
      c.name?.toLowerCase()?.includes(walletName?.toLowerCase())
    );

    return {
      name: walletName,
      connector: connector,
      isAvailable: !!connector
    };
  });
};